import moment from "moment-timezone";
import { FORMATS } from "../core/formats";
export function getPreviousDate(date) {
    return moment(date, FORMATS.moment.date)
        .subtract(1, "day")
        .format(FORMATS.moment.date);
}
export function getNextDate(date) {
    return moment(date, FORMATS.moment.date)
        .add(1, "day")
        .format(FORMATS.moment.date);
}
export function getLocalDate(time, tz) {
    return moment.tz(time, tz).format(FORMATS.moment.date_friendly);
}
export function getLocalTime(time, tz) {
    return moment.tz(time, tz).format(FORMATS.moment.time_second);
}
//# sourceMappingURL=index.js.map